/** Globally fetch subscription details for authenticated users */
export default defineNuxtPlugin({
  name: 'subscription-fetch',
  dependsOn: ['user-fetch'],
  setup: async () => {
    const userStore = useUserStore();
    const subscriptionStore = useSubscriptionStore();

    if (userStore.subscriptionIds.length) {
      await subscriptionStore.fetchSubscriptions(userStore.subscriptionIds);

      if (subscriptionStore.error) {
        console.error('Failed to fetch subscription on app load:', subscriptionStore.error);
        useO11y().reportError(subscriptionStore.error, { context: 'subscription_fetch_on_load' });
      }
    }

    useSubscriptionBanner();
  },
});